import type { UploadedFile } from "../schema/UploadedFile.js";

export function isFileVideo(file: UploadedFile): boolean {
	return file.type.startsWith("video/");
}
